import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const ConcelloInventarioTanquesSection = ({concello}) => {
    return (
        <SectionCard title="Tanques">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Totais:"
                        value={NumberUtil.formatInteger(concello.stats.tanques)}
                        tooltipText="Número de tanques de tormenta instalados na rede"
                    />
                    <SectionField
                        label="Volume:"
                        value={NumberUtil.formatDecimal(
                            concello.stats.capacidadetanque
                        )}
                        tooltipText="Volume total de retención"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default ConcelloInventarioTanquesSection;
